// Tüm oranlar TRY'ye göredir. 1 EUR = 47.47 TRY gibi.
// Bu oranlar sadece birer örnektir ve periyodik olarak güncellenmelidir.
export const rates = {
  'TRY': 1,
  'EUR': 47.47,
  'USD': 40.62,
  'GBP': 54.70,
  'AUD': 26.59,
  'CAD': 29.51,
  'CHF': 50.41,
  'CNY': 5.65,
  'JPY': 0.28,
  'SEK': 4.24,
  'SGD': 31.72,
  'KRW': 0.029,

};